<div class="container">
  @if (user) {
    <div class="w-100">
      <section class="profile-section">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-4">
            <div class="profile-picture rounded-circle position-relative">
              <img
                [src]="user.profilePictureUrl || '/profile-placeholder.png'"
                alt="Profile Picture"
                class="rounded-circle"
                />
              <input type="file" accept="image/*" hidden (change)="onProfilePictureSelected($event)" />
              <i
                class="bi bi-camera-fill camera-icon"
                (click)="onUploadProfilePicture()"
                >
              </i>
            </div>
            <div>
              <div class="fw-bold user-name">{{user.name}} {{user.surname}}</div>
              <div>{{user.email}}</div>
            </div>
          </div>
          <div class="text-end">
            <div class="fw-500">{{ organizationCount }} organizations</div>
            <div class="fw-500">{{ projectCount }} projects</div>
          </div>
        </div>
      </section>
      <section class="profile-section">
        <div class="d-flex align-items-center justify-content-between">
          <h2 class="section-title">Personal Information</h2>
          @if (!isEditingPersonal) {
            <button class="btn btn-primary d-flex align-items-center gap-3" (click)="togglePersonal()">
              Edit
              <i class="bi bi-pencil"></i>
            </button>
          } @else {
            <div class="d-flex gap-2">
              <button class="btn btn-light" type="button" (click)="togglePersonal()">Cancel</button>
              <button class="btn btn-primary d-inline-flex align-items-center gap-2" type="button" [disabled]="isSaving" (click)="updateUser()">
                @if (!isSaving) {
                  Save
                } @else {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>Saving...</span>
                }
              </button>
            </div>
          }
        </div>
        <hr />
        <div class="d-grid">
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="text-muted fw-light">First Name</div>
              @if (!isEditingPersonal) {
                <div class="fw-500">{{user.name}}</div>
              } @else {
                <input class="form-control" [(ngModel)]="user.name" placeholder="First name" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">Last Name</div>
              @if (!isEditingPersonal) {
                <div class="fw-500">{{user.surname}}</div>
              } @else {
                <input class="form-control" [(ngModel)]="user.surname" placeholder="Last name" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">CV/Resume</div>
              <input id="cvInput" type="file" accept="application/pdf,.pdf" hidden (change)="onCVSelected($event)" />
              @if(user.cvPdfUrl){
                <div class="d-flex align-items-center gap-2">
                  <a class="btn btn-outline-primary d-flex align-items-center gap-2" [href]="user.cvPdfUrl" target="_blank" rel="noopener" title="View CV/Resume">
                    <i class="bi bi-eye"></i>
                    <span>View</span>
                  </a>
                  <button (click)="onUploadCV()" class="btn btn-primary d-flex align-items-center gap-2" title="Replace CV/Resume">
                    <span>Replace</span>
                    <i class="bi bi-upload"></i>
                  </button>
                </div>
              } @else {
                <button (click)="onUploadCV()" class="btn btn-primary d-flex align-items-center gap-3">
                  Upload
                  <i class="bi bi-upload"></i>
                </button>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="text-muted fw-light">Email</div>
              @if (!isEditingPersonal) {
                <div class="fw-500">{{user.email}}</div>
              } @else {
                <input class="form-control" [(ngModel)]="user.email" placeholder="Email" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">Password</div>
              <div class="fw-500">********</div>
            </div>
          </div>
        </div>
      </section>
      <section class="profile-section">
        <div class="d-flex align-items-center justify-content-between">
          <h2 class="section-title">Social Links</h2>
          @if (!isEditingSocial) {
            <button class="btn btn-primary d-flex align-items-center gap-3" (click)="toggleSocial()">
              Edit
              <i class="bi bi-pencil"></i>
            </button>
          } @else {
            <div class="d-flex gap-2">
              <button class="btn btn-light" type="button" (click)="toggleSocial()">Cancel</button>
              <button class="btn btn-primary d-inline-flex align-items-center gap-2" type="button" [disabled]="isSaving" (click)="updateUser()">
                @if (!isSaving) {
                  Save
                } @else {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>Saving...</span>
                }
              </button>
            </div>
          }
        </div>
        <hr />
        <div class="d-grid">
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="text-muted fw-light">LinkedIn</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.linkedinUrl" icon="bi-linkedin" type="LinkedIn"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.linkedinUrl" placeholder="LinkedIn URL" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">GitHub</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.githubUrl" icon="bi-github" type="GitHub"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.githubUrl" placeholder="GitHub URL" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">Twitter</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.twitterUrl" icon="bi-twitter" type="Twitter"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.twitterUrl" placeholder="Twitter URL" />
              }
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="text-muted fw-light">Facebook</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.facebookUrl" icon="bi-facebook" type="Facebook"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.facebookUrl" placeholder="Facebook URL" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">Instagram</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.instagramUrl" icon="bi-instagram" type="Instagram"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.instagramUrl" placeholder="Instagram URL" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">YouTube</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.youtubeUrl" icon="bi-youtube" type="YouTube"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.youtubeUrl" placeholder="YouTube URL" />
              }
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="text-muted fw-light">TikTok</div>
              @if (!isEditingSocial) {
                <app-social-link [url]="user.tiktokUrl" icon="bi-tiktok" type="TikTok"></app-social-link>
              } @else {
                <input class="form-control" [(ngModel)]="user.tiktokUrl" placeholder="TikTok URL" />
              }
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">&nbsp;</div>
              <div></div>
            </div>
            <div class="col-md-4">
              <div class="text-muted fw-light">&nbsp;</div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  }
</div>
